import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EmrsidebarComponent} from './emrsidebar.component';
import {EmrCasePaperComponent} from './emr-case-paper/emr-case-paper.component';

const routes: Routes = [

    {
        path: 'emrsidebar', component: EmrsidebarComponent,
        children: [
            {path: 'emr-patient-list', loadChildren: 'app/emrsidebar/emr-patient-list/emr-patient-list.module#EmrPatientListModule'},
            {path: 'emr-patient-queue', loadChildren: 'app/emrsidebar/emr-patient-queue/emr-patient-queue.module#EmrPatientQueueModule'},
            {path: 'emr-patient-queue/:visitId', loadChildren: 'app/emrsidebar/emr-patient-queue/emr-patient-queue.module#EmrPatientQueueModule'},
            {path: 'emr-patient-registration', loadChildren: 'app/emrsidebar/patient-registration-search/patient-registration-search.module#PatientRegistrationSearchModule'},
            {path: 'quick-patient-registration', loadChildren: 'app/emrsidebar/patient-registration-search/patient-registration-search.module#PatientRegistrationSearchModule'},
            {path: 'emr-patient-registration/:patientId', loadChildren: 'app/emrsidebar/patient-registration-search/patient-registration-search.module#PatientRegistrationSearchModule'},
            {path: 'emr-patient-registration-edit/:patientId', loadChildren: 'app/emrsidebar/patient-registration-search/patient-registration-search.module#PatientRegistrationSearchModule'}
            // {path: 'emr-case-paper/:source/:visit_id', loadChildren: 'app/emrsidebar/emr-case-paper/emr-case-paper.module#EmrCasePaperModule'}

        ],

    },
    {
        path: 'emr-case-paper/:source/:visit_id', component: EmrCasePaperComponent
    },
    {
        path: 'emr-case-paper/:source/:visit_id/:byHistory', component: EmrCasePaperComponent
    }

];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emrsidebar.routing.ts